/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DateRangeFilter } from './DateRangeFilter';
import {
    DateRangeFilterFromJSON,
    DateRangeFilterFromJSONTyped,
    DateRangeFilterToJSON,
    DateRangeFilterToJSONTyped,
} from './DateRangeFilter';
import type { OrderByParams } from './OrderByParams';
import {
    OrderByParamsFromJSON,
    OrderByParamsFromJSONTyped,
    OrderByParamsToJSON,
    OrderByParamsToJSONTyped,
} from './OrderByParams';
import type { NumberRangeFilter } from './NumberRangeFilter';
import {
    NumberRangeFilterFromJSON,
    NumberRangeFilterFromJSONTyped,
    NumberRangeFilterToJSON,
    NumberRangeFilterToJSONTyped,
} from './NumberRangeFilter';
import type { FindListingsAv8RequestAreaFilter } from './FindListingsAv8RequestAreaFilter';
import {
    FindListingsAv8RequestAreaFilterFromJSON,
    FindListingsAv8RequestAreaFilterFromJSONTyped,
    FindListingsAv8RequestAreaFilterToJSON,
    FindListingsAv8RequestAreaFilterToJSONTyped,
} from './FindListingsAv8RequestAreaFilter';

/**
 * 
 * @export
 * @interface SearchParamsMap
 */
export interface SearchParamsMap {
    /**
     * 
     * @type {FindListingsAv8RequestAreaFilter}
     * @memberof SearchParamsMap
     */
    areaFilter?: FindListingsAv8RequestAreaFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    price?: NumberRangeFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchParamsMap
     */
    propertyStatus?: Array<SearchParamsMapPropertyStatusEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchParamsMap
     */
    propertyTypes?: Array<SearchParamsMapPropertyTypesEnum>;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    bedroomsCount?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    bathroomsCount?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    livingSpaceSqFt?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    lotSizeSqFt?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    parkingGarageSpaces?: NumberRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    homeownerAssociationFeeUSD?: NumberRangeFilter;
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof SearchParamsMap
     */
    soldDate?: DateRangeFilter;
    /**
     * 
     * @type {DateRangeFilter}
     * @memberof SearchParamsMap
     */
    listDate?: DateRangeFilter;
    /**
     * 
     * @type {NumberRangeFilter}
     * @memberof SearchParamsMap
     */
    propertyYearBuilt?: NumberRangeFilter;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchParamsMap
     */
    agentDreNumbers?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchParamsMap
     */
    hasDoormanAttendance?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchParamsMap
     */
    waterfrontClassification?: Array<SearchParamsMapWaterfrontClassificationEnum>;
    /**
     * 
     * @type {OrderByParams}
     * @memberof SearchParamsMap
     */
    orderResultsBy?: OrderByParams;
    /**
     * 
     * @type {number}
     * @memberof SearchParamsMap
     */
    paginationPage?: number;
    /**
     * Maximum number of results to return for map search
     * @type {number}
     * @memberof SearchParamsMap
     */
    paginationLimit?: number;
    /**
     * Detailed results include text description and all photos.
     * @type {boolean}
     * @memberof SearchParamsMap
     */
    detailedResults: boolean;
}


/**
 * @export
 */
export const SearchParamsMapPropertyStatusEnum = {
    Active: 'active',
    ActiveUnderContract: 'active-under-contract',
    ComingSoon: 'coming-soon',
    Contingent: 'contingent',
    Expired: 'expired',
    OffMarket: 'off-market',
    Pending: 'pending',
    Sold: 'sold',
    PendingBackupOfferRequested: 'pending-backup-offer-requested'
} as const;
export type SearchParamsMapPropertyStatusEnum = typeof SearchParamsMapPropertyStatusEnum[keyof typeof SearchParamsMapPropertyStatusEnum];

/**
 * @export
 */
export const SearchParamsMapPropertyTypesEnum = {
    Lease: 'Lease > *',
    LeaseCanonicalCommercial: 'Lease > CANONICAL > Commercial > *',
    LeaseCanonicalCommercialGeneral: 'Lease > CANONICAL > Commercial > General',
    LeaseCanonicalResidential: 'Lease > CANONICAL > Residential > *',
    LeaseCanonicalResidentialGeneral: 'Lease > CANONICAL > Residential > General',
    Sale: 'Sale > *',
    SaleCanonicalBusinessOpportunity: 'Sale > CANONICAL > Business Opportunity > ',
    SaleCanonicalBusinessOpportunity2: 'Sale > CANONICAL > Business Opportunity > *',
    SaleCanonicalCommercial: 'Sale > CANONICAL > Commercial > *',
    SaleCanonicalCommercialGeneral: 'Sale > CANONICAL > Commercial > General',
    SaleCanonicalLand: 'Sale > CANONICAL > Land > *',
    SaleCanonicalLandFarm: 'Sale > CANONICAL > Land > Farm',
    SaleCanonicalLandGeneral: 'Sale > CANONICAL > Land > General',
    SaleCanonicalResidential: 'Sale > CANONICAL > Residential > *',
    SaleCanonicalResidentialCondominium: 'Sale > CANONICAL > Residential > Condominium',
    SaleCanonicalResidentialCoOwnership: 'Sale > CANONICAL > Residential > Co-Ownership',
    SaleCanonicalResidentialIncome: 'Sale > CANONICAL > Residential Income > *',
    SaleCanonicalResidentialIncomeGeneral: 'Sale > CANONICAL > Residential Income > General',
    SaleCanonicalResidentialManufactured: 'Sale > CANONICAL > Residential > Manufactured',
    SaleCanonicalResidentialSingleFamilyResidence: 'Sale > CANONICAL > Residential > Single Family Residence'
} as const;
export type SearchParamsMapPropertyTypesEnum = typeof SearchParamsMapPropertyTypesEnum[keyof typeof SearchParamsMapPropertyTypesEnum];

/**
 * @export
 */
export const SearchParamsMapWaterfrontClassificationEnum = {
    Waterfront: 'waterfront',
    NearWater: 'near_water'
} as const;
export type SearchParamsMapWaterfrontClassificationEnum = typeof SearchParamsMapWaterfrontClassificationEnum[keyof typeof SearchParamsMapWaterfrontClassificationEnum];


/**
 * Check if a given object implements the SearchParamsMap interface.
 */
export function instanceOfSearchParamsMap(value: object): value is SearchParamsMap {
    if (!('detailedResults' in value) || value['detailedResults'] === undefined) return false;
    return true;
}

export function SearchParamsMapFromJSON(json: any): SearchParamsMap {
    return SearchParamsMapFromJSONTyped(json, false);
}

export function SearchParamsMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchParamsMap {
    if (json == null) {
        return json;
    }
    return {
        
        'areaFilter': json['areaFilter'] == null ? undefined : FindListingsAv8RequestAreaFilterFromJSON(json['areaFilter']),
        'price': json['price'] == null ? undefined : NumberRangeFilterFromJSON(json['price']),
        'propertyStatus': json['propertyStatus'] == null ? undefined : json['propertyStatus'],
        'propertyTypes': json['propertyTypes'] == null ? undefined : json['propertyTypes'],
        'bedroomsCount': json['bedroomsCount'] == null ? undefined : NumberRangeFilterFromJSON(json['bedroomsCount']),
        'bathroomsCount': json['bathroomsCount'] == null ? undefined : NumberRangeFilterFromJSON(json['bathroomsCount']),
        'livingSpaceSqFt': json['livingSpaceSqFt'] == null ? undefined : NumberRangeFilterFromJSON(json['livingSpaceSqFt']),
        'lotSizeSqFt': json['lotSizeSqFt'] == null ? undefined : NumberRangeFilterFromJSON(json['lotSizeSqFt']),
        'parkingGarageSpaces': json['parkingGarageSpaces'] == null ? undefined : NumberRangeFilterFromJSON(json['parkingGarageSpaces']),
        'homeownerAssociationFeeUSD': json['homeownerAssociationFeeUSD'] == null ? undefined : NumberRangeFilterFromJSON(json['homeownerAssociationFeeUSD']),
        'soldDate': json['soldDate'] == null ? undefined : DateRangeFilterFromJSON(json['soldDate']),
        'listDate': json['listDate'] == null ? undefined : DateRangeFilterFromJSON(json['listDate']),
        'propertyYearBuilt': json['propertyYearBuilt'] == null ? undefined : NumberRangeFilterFromJSON(json['propertyYearBuilt']),
        'agentDreNumbers': json['agentDreNumbers'] == null ? undefined : json['agentDreNumbers'],
        'hasDoormanAttendance': json['hasDoormanAttendance'] == null ? undefined : json['hasDoormanAttendance'],
        'waterfrontClassification': json['waterfrontClassification'] == null ? undefined : json['waterfrontClassification'],
        'orderResultsBy': json['orderResultsBy'] == null ? undefined : OrderByParamsFromJSON(json['orderResultsBy']),
        'paginationPage': json['paginationPage'] == null ? undefined : json['paginationPage'],
        'paginationLimit': json['paginationLimit'] == null ? undefined : json['paginationLimit'],
        'detailedResults': json['detailedResults'],
    };
}

export function SearchParamsMapToJSON(json: any): SearchParamsMap {
    return SearchParamsMapToJSONTyped(json, false);
}

export function SearchParamsMapToJSONTyped(value?: SearchParamsMap | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'areaFilter': FindListingsAv8RequestAreaFilterToJSON(value['areaFilter']),
        'price': NumberRangeFilterToJSON(value['price']),
        'propertyStatus': value['propertyStatus'],
        'propertyTypes': value['propertyTypes'],
        'bedroomsCount': NumberRangeFilterToJSON(value['bedroomsCount']),
        'bathroomsCount': NumberRangeFilterToJSON(value['bathroomsCount']),
        'livingSpaceSqFt': NumberRangeFilterToJSON(value['livingSpaceSqFt']),
        'lotSizeSqFt': NumberRangeFilterToJSON(value['lotSizeSqFt']),
        'parkingGarageSpaces': NumberRangeFilterToJSON(value['parkingGarageSpaces']),
        'homeownerAssociationFeeUSD': NumberRangeFilterToJSON(value['homeownerAssociationFeeUSD']),
        'soldDate': DateRangeFilterToJSON(value['soldDate']),
        'listDate': DateRangeFilterToJSON(value['listDate']),
        'propertyYearBuilt': NumberRangeFilterToJSON(value['propertyYearBuilt']),
        'agentDreNumbers': value['agentDreNumbers'],
        'hasDoormanAttendance': value['hasDoormanAttendance'],
        'waterfrontClassification': value['waterfrontClassification'],
        'orderResultsBy': OrderByParamsToJSON(value['orderResultsBy']),
        'paginationPage': value['paginationPage'],
        'paginationLimit': value['paginationLimit'],
        'detailedResults': value['detailedResults'],
    };
}

